function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.2 5.778h-2.853L14.7 4H9.3L7.657 5.778H4.8c-.477.001-.934.19-1.271.522A1.772 1.772 0 003 7.556v10.666c.001.471.191.923.529 1.256.337.333.794.52 1.271.522h14.4c.477-.001.934-.19 1.271-.522.338-.333.528-.785.529-1.256V7.556a1.772 1.772 0 00-.529-1.256 1.817 1.817 0 00-1.271-.522zm.3 12.722h-15V7.28h3.945l1.642-1.78h3.816l1.652 1.78H19.5V18.5z",
  fill: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12.5,
  r: 3.25,
  stroke: "currentColor",
  strokeWidth: 1.5
});

function SvgCameraIcon2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgCameraIcon2;